import "./HeaderCustomer.css"
import LogoHeader from '../../Assets/Images/logo-phl-login-page-update.svg.png'
import CustomChangeLanguage from "../../Components/custom-change-language/CustomChangeLanguage"
export default function HeaderCustomer() {
    return (
        <header className="header-customer">
            <div className="col-md-6 col-start">
                <img src={LogoHeader} />
            </div>
            <div className="col-md-6 col-end">
                <span className="description-large-customer">Hotline: <span>1900 886 838</span></span>
            </div>
            {/* <CustomChangeLanguage /> */}
        </header>
    )
};
